module.exports = __webpack_public_path__ + "img/presale-detail3.0c8142e4.png";